import * as React from 'react';
import './multiToggler.scss';
import { cn } from '../../utils';

type Disabled<D> = boolean | ((d: D) => boolean);

interface Props<D> {
  checked?: D;
  options: D[];
  disabled?: Disabled<D>;
  onChange?: (d: D) => void;
  getLabel?: (d: D) => string;
}
let id = 0;

const isDisabled = <D,>(opt: D, disabled: Disabled<D>): boolean => {
  if (typeof disabled == 'function') {
    return disabled(opt);
  }
  return disabled;
};

const defaultGetLabel = (d: any) => {
  if (typeof d == 'string') return d;
  if (!d) return JSON.stringify(d);
  let txt = d.label || d.name || d.description;
  if (txt) return txt;
  if (typeof d == 'object') {
    for (const [k, v] of Object.entries(d)) {
      if (typeof v == 'string') return v;
    }
  }
};

export const MultiToggler = <D,>({
  checked,
  options,
  onChange,
  disabled,
  getLabel = defaultGetLabel
}: Props<D>) => {
  const name = React.useMemo(() => 'multiToggler' + ++id, []);
  return (
    <div className={'multi-toggler btn-group btn-group-toggle'}>
      {options?.map((o, i) => {
        const oDisabled = isDisabled(o, disabled);
        return (
          <label
            key={i}
            className={cn('multi-toggler-button btn btn-info', {
              active: o == checked,
              disabled: oDisabled
            })}
          >
            <input
              type="radio"
              disabled={oDisabled}
              name={name}
              checked={o == checked}
              onChange={() => {
                if (!oDisabled) onChange(o);
              }}
            />
            {getLabel(o)}
          </label>
        );
      })}
    </div>
  );
};
